const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the User Manager Directive to display a list or table with users to manage
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Users the resource defined to get and set User data
 * @argument {Resource} Analyze the resource defined to get and set User data
 */
app.directive('userManager', ['Application', 'AdminUsers', 'Users', 'AccessHelper', function (Application, AdminUsers, Users, AccessHelper) {
    return {
      restrict: 'E',
      scope: {
        refresh: '=',
        callRefresh: '&'
      },
      replace: true,
      template: require('../../templates/directives/user-manager.html'),
      controller: ['$scope', '$translate', function ($scope, $translate) {
          var self = this;

          self.allowance = {
            add: AccessHelper.isAllowed(['admin', 'users', 'add'], null, ['admin']),
            edit: AccessHelper.isAllowed(['admin', 'users', 'edit'], null, ['admin']),
            view: AccessHelper.isAllowed(['admin', 'users', 'view'], null, ['admin']),
            suspend: AccessHelper.isAllowed(['admin', 'users', 'suspend'], null, ['admin']),
            password_reset: AccessHelper.isAllowed(['admin', 'users', 'password_reset'], null, ['admin'])
          };

          if (!self.allowance.view) {
            Application.navigation.goTo('/explore');
            return;
          }

          self.searchQuery = {};
          self.showSuspendConfirmation = false;
          self.showResetPasswordConfirmation = false;
          self.users = [];
          self.per_page = 20;
          self.usersRemoved = 0;
          self.selection = [];
          self.selectionBlock = {};
          self.currentTab = 'confirmed';
          self.loading = false;

          var getStandardQuery = function(){
            return {
              subresource: '',
              page: 1,
              per_page: self.per_page,
              'linked_locations-populate': 'name',
              'linked_departments-populate': 'name',
              queries: []
            };
          };
          self.query = getStandardQuery();
          self.initialize = function () {
            self.load();
          };
          self.load = function () {
            self.loading = true;
            AdminUsers.find(self.query, function (users) {
              self.users = users;
              self.usersRemoved = 0;
              self.loading = false;
            }, function (error) {
              self.loading = false;
              console.log('Error getting users:', error);
            });
          };
          self.previous = function () {
            if (self.query.page === 1) {
              return;
            }
            self.query.page--;
            if (self.query.queries && self.query.queries.length) {
              return self.queryLoad();
            }
            self.load();
          };
          self.next = function () {
            if (self.users.length !== self.per_page && !self.usersRemoved) {
              return;
            }
            self.query.page++;
            if (self.query.queries && self.query.queries.length) {
              return self.queryLoad();
            }
            self.load();
          };
          self.select = function (id, user) {
            self.selectionBlock[id] = user;
            var index = self.selection.indexOf(id);
            if (index === -1) {
              self.selection.push(id);
              return;
            }
            self.selection.splice(index, 1);
          };
          self.image = function (user) {
            if (user.image) {
              return user.image.replace('http:', 'https:').replace('http%', 'https%');
            }
            return 'img/avatar-default.png';
          };
          self.goToAddUsders = function () {
            Application.navigation.goTo('users/add');
          };
          self.confirmSuspend = function () {
            self.showSuspendConfirmation = true;
          };
          self.cancelSuspend = function () {
            self.selection.length = 0;
            self.showSuspendConfirmation = false;
          };
          self.suspend = function () {
            self.loading = true;
            Users.suspend({}, {users: self.selection}, function (data) {
              self.selection.forEach(function (id) {
                for (var index = self.users.length; index >= 0; index--) {
                  if (!self.users[index] || !self.users[index]._id || self.users[index]._id.toString() !== id) {
                    continue;
                  }
                  // ** Reminder to add suspend record option
                  // Analyze.record({resource: 'deletions'}, {document: id, type: 'user'});
                  self.users.splice(index, 1);
                  self.usersRemoved++;
                  break;
                }
              });
              self.cancelSuspend();
              self.loading = false;
              $scope.callRefresh({type: 'active'});

              $translate(['userManager.requested_accounts_suspended']).then(function(localtranslations){
                self.localTranslations = localtranslations;
                Application.messaging.addMessage({type: 'success', text: self.localTranslations['userManager.requested_accounts_suspended'], duration: 5});
              });

              }, function (error) {
              console.log('Error deleting users:', error);
              self.loading = false;
              self.cancelSuspend();
            });
          };
          self.confirmResetPassword = function () {
            self.showResetPasswordConfirmation = true;
          };
          self.cancelResetPassword = function () {
            self.selection.length = 0;
            self.showResetPasswordConfirmation = false;
          };
          self.resetPassword = function () {
            self.loading = true;
            Users.resetting({}, {users: self.selection}, function (data) {
              self.selection.forEach(function (id) {
                for (var index = self.users.length; index >= 0; index--) {
                  if (!self.users[index] || !self.users[index]._id || self.users[index]._id.toString() !== id) {
                    continue;
                  }
                  // ** Reminder to add suspend record option
                  // Analyze.record({resource: 'deletions'}, {document: id, type: 'user'});
                  self.users.splice(index, 1);
                  self.usersRemoved++;
                  break;
                }
              });
              self.cancelResetPassword();
              self.loading = false;
              $scope.callRefresh({type: 'active'});

              $translate(['userManager.requested_accounts_reset']).then(function(localtranslations){
                self.localTranslations = localtranslations;
                Application.messaging.addMessage({type: 'success', text: self.localTranslations['userManager.requested_accounts_reset'], duration: 5});
              });

              }, function (error) {
              console.log('Error resetting users:', error);
              self.loading = false;
              self.cancelResetPassword();
            });
          };
          self.getLocation = function(user) {
            if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
              return user.linked_locations[0].name;
            }
            return '-----';
          };
          self.getDepartment = function(user) {
            if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
              return user.linked_departments[0].name;
            }
            return '-----';
          };
          self.newFilter = function(opts) {
            self.query = getStandardQuery();
            if (!opts) {
              self.load();
              return;
            }

            self.query.page = 1;

            self.query.queries.push(opts);

            self.queryLoad();
          };

          self.queryLoad = function() {
            AdminUsers.findFromQuery({}, self.query).$promise.then(function (results) {
              var users = results.users || [];
              self.usersRemoved = 0;
              self.users = users;
            }).catch(function(error) {
              console.log('error in findFromQuery: ', error)
            });
          };

          $scope.$watch('refresh', function(newVal, oldVal) {
            if (newVal && !oldVal) {
              self.query = getStandardQuery();
              self.load();
              $scope.refresh = false;
            }
          });

          $translate(['modules.notifications.users_wereDeleted']).then(function(data){
            self.translations = data;
            self.initialize();
          });

        }],
      controllerAs: 'manager'
    };
  }]);